import { render, staticRenderFns } from "./batch-express-btn.vue?vue&type=template&id=77b5bac6&"
import script from "./batch-express-btn.vue?vue&type=script&lang=js&"
export * from "./batch-express-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports